import { cn } from '@px-center/utils';
import { type JSX } from 'react';

type ErrorLayoutProps = JSX.IntrinsicElements['main'] & {
	title: string;
};

export const ErrorLayout = ({
	title,
	children,
	className,
	...rest
}: ErrorLayoutProps) => {
	return (
		<div>
			<title>{title}</title>
			<main
				className={cn(
					'flex w-full items-center justify-center bg-white',
					className,
				)}
				{...rest}
			>
				{children}
			</main>
		</div>
	);
};
